import React, { useState, useRef, useEffect } from 'react';
import Breadcrumbs from "../breadcrumbs/Breadcrumbs";
import { FiChevronDown, FiChevronUp, FiCheck } from 'react-icons/fi';
import { toast } from 'react-hot-toast';
// import 'react-toastify/dist/ReactToastify.css';
import Thumbnail1 from "../../assets/images/Products/productD-1.jpg";
import { useDispatch, useSelector } from 'react-redux';
import { clearCart } from '../../features/cart/cartSlice';
import { useNavigate } from 'react-router-dom';
import apiClient from '../../services/apiClient';
import { IMAGE_PATH } from '../../utils/constants';
import PaymentPopup from './PaymentPopup';
import Policy from './Policy';
// import { updateProfile } from '../../features/auth/authSlice';
const Checkout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const cartItems = useSelector(state => state.cart.items);
  const user = useSelector(state => state.auth.user);
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
  const [total, setTotal] = useState(0);
  const [subtotal, setSubtotal] = useState(0);
  const [shippingFee, setShippingFee] = useState(0);
  const [promoCode, setPromoCode] = useState('');
  const [promoMessage, setPromoMessage] = useState('');
  const [promoSuccess, setPromoSuccess] = useState(false);
  const [showPaymentPopup, setShowPaymentPopup] = useState(false);
  const [appliedCoupon, setAppliedCoupon] = useState(null);

  const breadcrumbItems = [
    { label: "Home", url: "/" },
    { label: "Products", url: "/products/product" },
    { label: "Checkout" },
  ];

  // Form states
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [secondaryPhone, setSecondaryPhone] = useState('');
  const [address, setAddress] = useState('');
  const [town, setTown] = useState('');
  const [postCode, setPostCode] = useState('');
  const [offerData, setOfferData] = useState(null);
  
  // Dropdown states
  const [showCountryDropdown, setShowCountryDropdown] = useState(false);
  const [showStateDropdown, setShowStateDropdown] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState('India');
  const [selectedState, setSelectedState] = useState('');

  //Dropdown delivery partner

  const [showDeliveryPartnerDropDown,setShowDeliveryPartnerDropDown] = useState(false);
  const [selectedDeliveryPartner,setSelectedDeliverPartner] = useState('E-Kart');
  const [selectedPartner,setSelectedPartner] = useState('ecart');
  const [deliveryComment,setDeliveryComment] = useState(null);
  
  // Billing address states
  const [billingSameAsDelivery, setBillingSameAsDelivery] = useState(true);
  const [requiresHomeDelivery, setRequiresHomeDelivery] = useState(false);
  const [billingFirstName, setBillingFirstName] = useState('');
  const [billingLastName, setBillingLastName] = useState('');
  const [billingAddress, setBillingAddress] = useState('');
  const [billingTown, setBillingTown] = useState('');
  const [billingPostCode, setBillingPostCode] = useState('');
  const [showBillingCountryDropdown, setShowBillingCountryDropdown] = useState(false);
  const [showBillingStateDropdown, setShowBillingStateDropdown] = useState(false);
  const [selectedBillingCountry, setSelectedBillingCountry] = useState('');
  const [selectedBillingState, setSelectedBillingState] = useState('');
  const [isPaymentProcessing, setIsPaymentProcessing] = useState(false);
  const [policiesAccepted, setPoliciesAccepted] = useState(true);

  // Refs for dropdown close handling
  const countryRef = useRef(null);
  const stateRef = useRef(null);
  const billingCountryRef = useRef(null);
  const billingStateRef = useRef(null);
  const deliverRef = useRef(null);

  // Data
  const countries = ['India'];
  const statesByCountry = {
  'India': [
    // States
    'Andhra Pradesh',
    'Arunachal Pradesh',
    'Assam',
    'Bihar',
    'Chhattisgarh',
    'Goa',
    'Gujarat',
    'Haryana',
    'Himachal Pradesh',
    'Jharkhand',
    'Karnataka',
    'Kerala',
    'Madhya Pradesh',
    'Maharashtra',
    'Manipur',
    'Meghalaya',
    'Mizoram',
    'Nagaland',
    'Odisha',
    'Punjab',
    'Rajasthan',
    'Sikkim',
    'Tamil Nadu',
    'Telangana',
    'Tripura',
    'Uttar Pradesh',
    'Uttarakhand',
    'West Bengal',

    // Union Territories
    'Andaman and Nicobar Islands',
    'Chandigarh',
    'Dadra and Nagar Haveli and Daman and Diu',
    'Delhi',
    'Jammu and Kashmir',
    'Ladakh',
    'Lakshadweep',
    'Puducherry',
  ]
};
  


  // Calculate totals
  useEffect(() => {
    
    let subtotal = 0;
    cartItems.forEach(item => {
      subtotal += item.sale_price * item.quantity;
    });
    setSubtotal(subtotal);

    //apply delivery shippent fee

    if (selectedPartner == 'ecart') {
      setDeliveryComment("Home delivery available, cash on delivery available");
      setShippingFee(50);
    } else {
      setDeliveryComment("Home delivery unavailable, cash on delivery unavailable");
      setShippingFee(0);
    }
    
    
    //appling offer
    if (offerData) {
      if(offerData.discount_type === 'amount'){
        const discount = offerData.discount_value;
        subtotal -= discount;
        toast.success(`Offer applied! You saved ₹${discount.toFixed(2)}`);
      } else if(offerData.discount_type === 'percentage'){
        const discount = subtotal * (offerData.discount_value / 100); 
        subtotal -= discount;
        toast.success(`Offer applied! You saved ₹${discount.toFixed(2)}`);
      }
    }
    

    setTotal(subtotal + shippingFee);
    
  }, [cartItems, shippingFee,offerData,selectedPartner]);

  useEffect(() => {
    let cleanup;

    const fetchOfferData = async () => {
      try {
        const res = await apiClient.get('/active-offers');
        const activeOffer = res.data.data.find(offer => offer.is_active);
        console.log("Fetched offers:", res.data.data);
        if (activeOffer) {
          setOfferData(activeOffer);
          // store cleanup function
        }
      } catch (error) {
        console.error("Error fetching offers:", error);
      }
    };

    fetchOfferData();

    return () => {
      if (cleanup) cleanup(); // clear interval on unmount or re-run
    };
  }, []);

  // Set user data if authenticated
  useEffect(() => {
    if (isAuthenticated && user) {
      setFirstName(user.name.split(' ')[0] || '');
      setLastName(user.name.split(' ').slice(1).join(' ') || '');
      setEmail(user.email || '');
      setPhone(user.phone || '');
    }
  }, [isAuthenticated, user]);

  useEffect(() => {
    if (!isAuthenticated) {
       toast.error("Please log in to continue checkout.");
      navigate("/auth/login");
    } else {
      apiClient.get("/user/profile").then((res) => {
        const data = res.data;
        console.log(data)
        if (data?.address) setAddress(data.address);
        if (data?.pincode) setPostCode(data.pincode);
        if (data?.state) setSelectedState(data.state);
        if (data?.city) setTown(data.city);
        if (data?.phone) setPhone(String(parseInt(data.phone)));
        if (data?.country) setSelectedCountry(String((data.country)));
        if (data?.secondary_phone) setSecondaryPhone(String(parseInt(data?.secondary_phone)));
      });
    }
  }, [isAuthenticated, navigate]);

  // Delivery address dropdown handlers
  const toggleCountryDropdown = () => {
    setShowCountryDropdown(!showCountryDropdown);
    if (showStateDropdown) setShowStateDropdown(false);
  };

  const toggleStateDropdown = () => {
    if (selectedCountry) {
      setShowStateDropdown(!showStateDropdown);
    }
    if (showCountryDropdown) setShowCountryDropdown(false);
  };

  const toggleDeliveryDropDown = () => {
    setShowDeliveryPartnerDropDown(!showDeliveryPartnerDropDown)
  }

  const handleDelivery = (value) => {
    if(value == 'ecart'){
      setSelectedDeliverPartner('E-Kart');
    }else if(value == 'courier'){
      setSelectedDeliverPartner('Courier Service');
    }else if(value == 'dtdc'){
      setSelectedDeliverPartner('DTDC');
    }else if(value == 'indianpost'){
      setSelectedDeliverPartner('Indian Speed Post');
    }
    setSelectedPartner(value);
    setShowDeliveryPartnerDropDown(false);
  }

  const selectCountry = (country) => {
    setSelectedCountry(country);
    setSelectedState('');
    setShowCountryDropdown(false);
  };

  const selectState = (state) => {
    setSelectedState(state);
    setShowStateDropdown(false);
  };

  // Billing address dropdown handlers
  const toggleBillingCountryDropdown = () => {
    setShowBillingCountryDropdown(!showBillingCountryDropdown);
    if (showBillingStateDropdown) setShowBillingStateDropdown(false);
  };

  const toggleBillingStateDropdown = () => {
    if (selectedBillingCountry) {
      setShowBillingStateDropdown(!showBillingStateDropdown);
    }
    if (showBillingCountryDropdown) setShowBillingCountryDropdown(false);
  };

  const selectBillingCountry = (country) => {
    setSelectedBillingCountry(country);
    setSelectedBillingState('');
    setShowBillingCountryDropdown(false);
  };

  const selectBillingState = (state) => {
    setSelectedBillingState(state);
    setShowBillingStateDropdown(false);
  };

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (countryRef.current && !countryRef.current.contains(event.target)) {
        setShowCountryDropdown(false);
      }
      if (stateRef.current && !stateRef.current.contains(event.target)) {
        setShowStateDropdown(false);
      }
      if (billingCountryRef.current && !billingCountryRef.current.contains(event.target)) {
        setShowBillingCountryDropdown(false);
      }
      if (billingStateRef.current && !billingStateRef.current.contains(event.target)) {
        setShowBillingStateDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  const isValidPhoneNumber = (phone) => {
    const phoneRegex = /^[0-9]{10,15}$/;
    return phoneRegex.test(phone);
  };

  // Form validation
  const validateForm = () => {
    if (cartItems.length === 0) {
      toast.error('Your cart is empty');
      navigate('/cart/cart')
      return false;
    }
    if (!firstName.trim()) {
      toast.error('First name is required');
      return false;
    }
    if (!email.trim()) {
      toast.error('Email is required');
      return false;
    }
    if (!phone.trim() && isValidPhoneNumber(phone)) {
      toast.error('Enter a valid phone number');
      return false;
    }
    if (phone.trim() === secondaryPhone.trim()) {
      toast.error('Secondary number cannot be same as primary number');
      return false;
       
    }
    if (!address.trim()) {
      toast.error('Address is required');
      console.error('address is required');
      return false;
    }
    if (!town.trim()) {
      toast.error('Town/City is required');
      return false;
    }
    if (!selectedCountry) {
      toast.error('Country is required');
      return false;
    }
    if (!selectedState) {
      toast.error('State is required');
      return false;
    }
    
    if (!/^\d{6}$/.test(postCode.trim())) {
        toast.error('Postal code must be 6 digits');
        return false;
    }

    
    if (!billingSameAsDelivery) {
      if (!billingFirstName.trim()) {
        toast.error('Billing first name is required');
        return false;
      }
      if (!billingAddress.trim()) {
        toast.error('Billing address is required');
        return false;
      }
      if (!billingTown.trim()) {
        toast.error('Billing town/city is required');
        return false;
      }
      if (!selectedBillingCountry) {
        toast.error('Billing country is required');
        return false;
      }
      if (!selectedBillingState) {
        toast.error('Billing state is required');
        return false;
      }
      if (!billingPostCode.trim()) {
        toast.error('Billing postal code is required');
        return false;
      }
    }

    if (!policiesAccepted) {
      toast.error('Please accept our shipping and return policies before proceeding');
      return;
    }
    
    return true;
  };



  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };


  const handleCashOnDelivery = async () => {
    if (!validateForm()) return;
    
    if (!policiesAccepted) {
      toast.error('Please accept our shipping and return policies before proceeding');
      return;
    }
    if (cartItems.length === 0) {
      toast.error('Your cart is empty');
      return;
    }

    if (!isValidPhoneNumber(phone)) {
      return toast.error('Please enter a valid phone number');
    }

    if (phone.trim() === secondaryPhone.trim()) {
      return toast.error('Secondary number cannot be same as primary number');
    }

    setIsPaymentProcessing(true);

    try {
      const response = await apiClient.post("/cod-checkout", {
        total,
        cart: cartItems,
        address,
        phone,
        secondary_phone: secondaryPhone,
        city: town,
        state: selectedState,
        country: selectedCountry,
        pincode: postCode,
        billing_address: billingSameAsDelivery ? address : billingAddress,
        billing_city: billingSameAsDelivery ? town : billingTown,
        billing_state: billingSameAsDelivery ? selectedState : selectedBillingState,
        billing_pincode: billingSameAsDelivery ? postCode : billingPostCode,
        billing_country: billingSameAsDelivery ? selectedCountry : selectedBillingCountry,
        shipping_fee: shippingFee,
        requires_home_delivery: requiresHomeDelivery,
        name: `${firstName} ${lastName}`,
        email: email,
        coupon_code: promoCode,
        deliver_partner: selectedPartner,
      });

      if (response.data.success) {
        dispatch(clearCart());
        toast.success("Order placed successfully! You will pay when your order is delivered.");
        navigate("/thank-you", { 
          state: { 
            orderId: response.data.order_id,
            isCod: true 
          } 
        });
      } else {
        toast.error(response.data.message || "Failed to place COD order");
      }
    } catch (error) {
      console.error('COD error:', error);
      toast.error(error.response?.data?.message || 'Failed to place COD order.');
    } finally {
      setIsPaymentProcessing(false);
    }
  };
  // Handle payment
  const handlePayment = async () => {
    if (!validateForm()) return;
    
    if (!policiesAccepted) {
    toast.error('Please accept our shipping and return policies before proceeding');
    return;
  }

    if (cartItems.length === 0) {
      toast.error('Your cart is empty');
      return;
    }

    if (!isValidPhoneNumber(phone)) {
      return toast.error('Please enter a valid phone number');
    }

    if (phone.trim() === secondaryPhone.trim()) {
      return toast.error('Secondary number cannot be same as primary number');
    }

    setIsPaymentProcessing(true);

    try {
      const razorpayLoaded = await loadRazorpayScript();
      if (!razorpayLoaded) {
        toast.error('Razorpay SDK failed to load');
        setIsPaymentProcessing(false);
        return;
      }

      const response = await apiClient.post("/prepare-payment-session", {
        total,
        cart: cartItems,
        address,
        phone,
        secondary_phone: secondaryPhone,
        city: town,
        state: selectedState,
        country: selectedCountry,
        pincode: postCode,
        billing_address: billingSameAsDelivery ? address : billingAddress,
        billing_city: billingSameAsDelivery ? town : billingTown,
        billing_state: billingSameAsDelivery ? selectedState : selectedBillingState,
        billing_pincode: billingSameAsDelivery ? postCode : billingPostCode,
        billing_country: billingSameAsDelivery ? selectedCountry : selectedBillingCountry,
        shipping_fee: shippingFee,
        requires_home_delivery: requiresHomeDelivery,
        name: isAuthenticated ? user?.name : `${firstName} ${lastName}`,
        email: isAuthenticated ? user?.email : email,
        amount: total * 100,
        coupon_code:promoCode,
        deliver_partner: selectedPartner,
      });

      const { order_id, currency } = response.data;
      console.log(import.meta.env.VITE_RAZORPAY_KEY)
      const options = {
        key: import.meta.env.VITE_RAZORPAY_KEY,
        amount: total * 100,
        currency: currency || 'INR',
        name: "Your Store Name",
        description: "Order Payment",
        order_id,
        prefill: {
          name: isAuthenticated ? user?.name : `${firstName} ${lastName}`,
          email: isAuthenticated ? user?.email : email,
          contact: phone,
        },
        theme: {
          color: "#1976d2",
        },
        handler: async function (response) {
          try {
            await apiClient.post("/verify-payment", {
              ...response,
              order_id: order_id,
            });
            
            dispatch(clearCart());
            toast.success("Payment successful!");
            navigate("/thank-you");
          } catch (err) {
            console.error(err);
            toast.error("Payment verification failed");
          } finally {
            setIsPaymentProcessing(false);
          }
        },
        modal: {
          ondismiss: function () {
            setIsPaymentProcessing(false);
            toast.info("Payment popup closed.");
          },
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
      
      rzp.on('payment.failed', function (response) {
        toast.error(`Payment failed: ${response.error.description}`);
        setIsPaymentProcessing(false);
      });

    } catch (error) {
      console.error('Payment error:', error);
      toast.error(error.response?.data?.message || 'Payment initiation failed.');
      setIsPaymentProcessing(false);
    }
  };

  const handleApplyPromo = async () => {
    if (!promoCode.trim()) {
      setPromoSuccess(false);
      setPromoMessage("Please enter a promo code");
      return;
    }

    try {
      const response = await apiClient.post('/coupons/validate', {
        coupon_code: promoCode.trim(),
      });

      console.log("Coupon validation response:", response.data);

      if (response.data.valid) {
        const coupon = response.data.data;
        console.log("Applied coupon:", coupon);
        // Calculate discount based on coupon type
        let discountAmount = 0;
        
        if (coupon.discount_type === 'percentage') {
          discountAmount = total * (coupon.discount_value / 100);
        } else if (coupon.discount_type === 'fixed') {
          discountAmount = Math.min(total, coupon.discount_value);
        }
        
        setPromoSuccess(true);
        console.log("Discount amount:", discountAmount);
        console.log("Total amount:", total);
        setPromoMessage(`Promo applied successfully! ${coupon.discount_value}${coupon.discount_type === 'percentage' ? '%' : ''} discount applied`);
        setTotal(prevTotal => prevTotal - discountAmount);
        setAppliedCoupon(coupon); 
        
    
        
      } else {
        setPromoSuccess(false);
        setPromoMessage(response.data.message || "Invalid promo code");
      }
    } catch (error) {
      console.error('Error applying promo code:', error);
      setPromoSuccess(false);
      setPromoMessage("Error applying promo code. Please try again.");
    }
  };

  // Function to remove applied promo
  const handleRemovePromo = () => {
    if (appliedCoupon) {
      // Recalculate total by adding back the discount
      let discountAmount = 0;
      
      if (appliedCoupon.discount_type === 'percentage') {
        discountAmount = (total + discountAmount) * (appliedCoupon.discount_value / 100);
      } else if (appliedCoupon.discount_type === 'amount') {
        discountAmount = appliedCoupon.discount_value;
      }
      
      setTotal(prevTotal => prevTotal + discountAmount);
      setAppliedCoupon(null);
      setPromoCode("");
      setPromoSuccess(false);
      setPromoMessage("Promo code removed");
    }
  };


  return (
    <div id='Checkout'>
      <div className="BreadCrumbsBox">
        <div className="container">
          <Breadcrumbs items={breadcrumbItems} />
        </div>
      </div>
      <div className="container">
        <div className="CheckoutMain">
          <div className='CheckoutLeft'>
            <div className="CheckoutHead">
              <h2>Delivery Information</h2>
            </div>
            <div className='CheckoutAddressBox'>
              <div className='AddressNameBox'>
                <input 
                  type="text" 
                  placeholder="First Name *" 
                  className="CheckoutInput"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  required
                />
                <input 
                  type="text" 
                  placeholder="Last Name" 
                  className="CheckoutInput"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                />
              </div>
              <div className='AddressEmailMobileBox'>
                <input 
                  type="email" 
                  placeholder="Email Address *" 
                  className="CheckoutInput"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className='AddressMobileBox'>
                {/* <div className='PrimaryPhoneBox'>
                  <input 
                    type="tel" 
                    placeholder="Primary Phone No. *" 
                    className="CheckoutInput"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    required
                  />
                  <span className='phone-info'>This number will be used for delivery — ensure it can receive calls and OTPs.</span>
                </div> */}
                <input 
                    type="tel" 
                    placeholder="Primary Phone No. *" 
                    className="CheckoutInput"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    required
                  />
                <input 
                  type="tel" 
                  placeholder="Secondary Phone No."
                  className="CheckoutInput"
                  value={secondaryPhone}
                  onChange={(e) => setSecondaryPhone(e.target.value)}
                />
                
              </div>
              
              {/* Address Textarea */}
              <div className='AddressFullBox'>
                <textarea
                  placeholder="Address"
                  className="CheckoutTextarea"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  required
                  rows={4}
                />
              </div>
              <div className="countryStateBox">
                <div className='AddressCountriesBox' ref={countryRef}>
                  <div 
                    className="DropdownInput" 
                    onClick={toggleCountryDropdown}
                  >
                    <input 
                      type="text" 
                      placeholder="Country/Region *" 
                      value={selectedCountry}
                      readOnly
                      required
                    />
                    {showCountryDropdown ? <FiChevronUp /> : <FiChevronDown />}
                  </div>
                  {showCountryDropdown && (
                    <ul className="DropdownMenu">
                      {countries.map(country => (
                        <li 
                          key={country} 
                          onClick={() => selectCountry(country)}
                          className={selectedCountry === country ? 'active' : ''}
                        >
                          {country}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
                
                <div className='AddressStatePostCodeBox' ref={stateRef}>
                  <div 
                    className="DropdownInput" 
                    onClick={toggleStateDropdown}
                  >
                    <input 
                      type="text" 
                      placeholder="Choose State *" 
                      value={selectedState}
                      readOnly
                      disabled={!selectedCountry}
                      required
                    />
                    {showStateDropdown ? <FiChevronUp /> : <FiChevronDown />}
                  </div>
                  {showStateDropdown && selectedCountry && (
                    <ul className="DropdownMenu">
                      {statesByCountry[selectedCountry]?.map(state => (
                        <li 
                          key={state} 
                          onClick={() => selectState(state)}
                          className={selectedState === state ? 'active' : ''}
                        >
                          {state}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
              
              <div className='AddressTownStreetBox'>
                <input 
                  type="text" 
                  placeholder="Town/City *" 
                  className="CheckoutInput"
                  value={town}
                  onChange={(e) => setTown(e.target.value)}
                  required
                />
                <input 
                  type="text" 
                  placeholder="Post Code *" 
                  className="CheckoutInput"
                  value={postCode}
                  onChange={(e) => setPostCode(e.target.value)}
                  required
                />
              </div>
              <div className='DeliveryPartnerBox' ref={deliverRef}>
                <div 
                  className="DropdownInput" 
                  onClick={toggleDeliveryDropDown}
                >
                  <input 
                    type="text" 
                    placeholder="Select Devlivery Partner" 
                    value={selectedDeliveryPartner}
                    readOnly
                    required
                  />
                  {showDeliveryPartnerDropDown ? <FiChevronUp /> : <FiChevronDown />}
                </div>
                {showDeliveryPartnerDropDown && (
                  <ul className="DropdownMenu">
                      <li 
                        onClick={() => handleDelivery('ecart')}
                        className={selectedPartner === 'ecart' ? 'active' : ''}
                      >
                        E-kart 
                      </li>
                      <li 
                        onClick={() => handleDelivery('courier')}
                        className={selectedPartner === 'courier' ? 'active' : ''}
                      >
                        Courier Service
                      </li>
                     
                  </ul>
                )}
                
                {deliveryComment && (<span className="deliver-comment">{deliveryComment}</span>)} 
              </div>
             
              
              <div className='AddressBillingBox'>
                <label className="CheckboxLabel">
                  <input 
                    type="checkbox"
                    checked={billingSameAsDelivery}
                    onChange={() => setBillingSameAsDelivery(!billingSameAsDelivery)}
                  />
                  <div className={`CheckboxCustom ${billingSameAsDelivery ? 'checked' : ''}`}>
                    {billingSameAsDelivery && <FiCheck className="CheckIcon" />}
                  </div>
                  <p>Billing address same as delivery address</p>
                </label>
              </div>
              
              {!billingSameAsDelivery && (
                <div className='BillingAddressSection'>
                  <h3>Billing Address</h3>
                  <div className='AddressNameBox'>
                    <input 
                      type="text" 
                      placeholder="First Name *" 
                      className="CheckoutInput"
                      value={billingFirstName}
                      onChange={(e) => setBillingFirstName(e.target.value)}
                      required
                    />
                    <input 
                      type="text" 
                      placeholder="Last Name" 
                      className="CheckoutInput"
                      value={billingLastName}
                      onChange={(e) => setBillingLastName(e.target.value)}
                    />
                  </div>
                  
                  {/* Billing Address Textarea - Matching Delivery Address */}
                  <div className='AddressFullBox'>
                    <textarea
                      placeholder="Billing Address (House No, Building, Street, Area) *"
                      className="CheckoutTextarea"
                      value={billingAddress}
                      onChange={(e) => setBillingAddress(e.target.value)}
                      required
                      rows={4}
                    />
                  </div>
                  <div className="countryStateBox">
                    <div className='AddressCountriesBox' ref={billingCountryRef}>
                      <div 
                        className="DropdownInput" 
                        onClick={toggleBillingCountryDropdown}
                      >
                        <input 
                          type="text" 
                          placeholder="Country/Region *" 
                          value={selectedBillingCountry}
                          readOnly
                          required
                        />
                        {showBillingCountryDropdown ? <FiChevronUp /> : <FiChevronDown />}
                      </div>
                      {showBillingCountryDropdown && (
                        <ul className="DropdownMenu">
                          {countries.map(country => (
                            <li 
                              key={country} 
                              onClick={() => selectBillingCountry(country)}
                              className={selectedBillingCountry === country ? 'active' : ''}
                            >
                              {country}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                    
                    <div className='AddressStatePostCodeBox' ref={billingStateRef}>
                      <div 
                        className="DropdownInput" 
                        onClick={toggleBillingStateDropdown}
                      >
                        <input 
                          type="text" 
                          placeholder="Choose State *" 
                          value={selectedBillingState}
                          readOnly
                          disabled={!selectedBillingCountry}
                          required
                        />
                        {showBillingStateDropdown ? <FiChevronUp /> : <FiChevronDown />}
                      </div>
                      {showBillingStateDropdown && selectedBillingCountry && (
                        <ul className="DropdownMenu">
                          {statesByCountry[selectedBillingCountry]?.map(state => (
                            <li 
                              key={state} 
                              onClick={() => selectBillingState(state)}
                              className={selectedBillingState === state ? 'active' : ''}
                            >
                              {state}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                  
                  
                  <div className='AddressTownStreetBox'>
                    <input 
                      type="text" 
                      placeholder="Town/City *" 
                      className="CheckoutInput"
                      value={billingTown}
                      onChange={(e) => setBillingTown(e.target.value)}
                      required
                    />
                    <input 
                      type="text" 
                      placeholder="Post Code *" 
                      className="CheckoutInput"
                      value={billingPostCode}
                      onChange={(e) => setBillingPostCode(e.target.value)}
                      required
                    />
                  </div>
                </div>
              )}

               {/* <Policy onPolicyAccept={(accepted) => {
                  setPoliciesAccepted(accepted);
                  // You might also want to reset the checkbox if policies change
                }} /> */}

              {/* <div className='PolicyBox'>
                 <div className='PolicyTitle'>
                <p>Please review and accept our policies</p> font size 15px font family myFont
              </div>
              <div className='PolicyCheckBox'>
                 <input type="checkbox" />
                 <label>Please Accept the <span>Shiping Policy</span>and <span>Return Policy</span> </label>
              </div>
              </div> */}
           
              
            </div>
          </div>
          
          {/* Order Summary Section */}
          <div className='CheckoutRight'>
            <div className="CheckoutHead">
              <h2>Order Summary</h2>
            </div>
            <div className='OrderSummaryBox'>
              <div className='OrderSummaryProductBox'>
                {cartItems.map((item) => (
                  <div className='SummaryBox' key={item.id}>
                    <div className='OrderSummaryList'>
                      <div className='SummaryImgBox'>
                        <img src={item.media?.[0]?.file_path ? `${IMAGE_PATH}${item.media[0].file_path}` : `${IMAGE_PATH}${item.image_path}` } alt={item.name} />
                      </div>
                      <div className='SummaryProductBox'>
                        <p className="product-name">{item.name}</p>
                        <p className="product-size">{item.is_combo ? 'Combo Offer' : `Size: ${item.size}`}</p>
                        <p className="product-quantity">Qty: {item.quantity}</p>
                      </div>
                    </div>
                    <div className='ProductPrice'>
                      <p>₹{item.sale_price * item.quantity}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/* Order Totals */}
              <div className='shipingTotalBox'>
                <div className='SubTotalBox'>
                  <p>Subtotal</p>
                  <p>₹{subtotal}</p>
                </div>
                <div className='PromotionBox'>
                <div className='PromocodeApplyBox'>
                  <input 
                    type="text" 
                    placeholder="Enter Coupon Code"
                    value={promoCode}
                    onChange={(e) => setPromoCode(e.target.value)}
                  />
                  <button onClick={handleApplyPromo} disabled={promoSuccess}>{promoSuccess ? 'Applied':'Apply'}</button>
              
             
                </div>
                     <div className='PromotionMsg'>
                    {promoMessage && (
                    <p className={`promo-message ${promoSuccess ? 'success' : 'error'}`}>
                      {promoMessage}
                    </p>
                  )}
                   </div>
                </div> 
             

                <div className='SippingBox'>
                  <p>Shipping</p>
                  <p>{shippingFee === 0 ? 'Free' : `₹${shippingFee}`}</p>
                </div>
                
                <div className='TotalBox'>
                  <p>Total</p>
                  <p>₹{total}</p>
                </div>
              </div>
            </div>
            <div className='MakePaymentBtn'>
            <button onClick={() => {
              if(validateForm()) {
                setShowPaymentPopup(true)
              }
              }}>
              Make a payment
            </button>
             </div>

          {showPaymentPopup && (
            <PaymentPopup 
              onClose={() => setShowPaymentPopup(false)} 
              onContinue={(method) => {
                setShowPaymentPopup(false);
                if (method === "razorpay") {
                  handlePayment();
                } else {
                  handleCashOnDelivery();
                }
              }} 
              selectedPartner={selectedPartner}
            />
          )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Checkout;